import React from "react";
import { useNavigate } from "react-router-dom";
import AllocationDetails from "../AllocationDetails/AllocationDetails";
import { JOURNAL_PATH } from "../../constants";
import "./ResultStep.css";

const SuccessIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M6 12.5L10 16.5L18 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Шаг 5: итог проведённого распределения */
function ResultStep({ record, onNewAllocation, onOpenHistory }) {
  const navigate = useNavigate();

  return (
    <div className="al-result">
      <div className="al-result__banner">
        <span className="al-result__icon">
          <SuccessIcon />
        </span>
        <div className="al-result__text">
          <div className="al-result__title">
            {record.restarted ? "Распределение перезапущено" : "Распределение создано"}
          </div>
          <div className="al-result__subtitle">
            {record.document} от {record.date} · сформировано управленческих операций:{" "}
            {record.entries.length}
          </div>
        </div>
        <div className="al-result__actions">
          <button
            type="button"
            className="oj-btn oj-btn--secondary"
            onClick={() => navigate(JOURNAL_PATH)}
          >
            Перейти в журнал операций
          </button>
          <button type="button" className="oj-btn oj-btn--secondary" onClick={onOpenHistory}>
            История распределений
          </button>
          <button type="button" className="oj-btn oj-btn--primary" onClick={onNewAllocation}>
            Новое распределение
          </button>
        </div>
      </div>

      <AllocationDetails record={record} />
    </div>
  );
}

export default ResultStep;
